import styled from 'styled-components';
import { HeaderSection } from '../HeaderSection';

export const ElementsQuantityStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0.02em;
  margin: 0;
`;

export const QuantityStyled = styled.b`
  margin-right: 0.5rem;
`;

export const HeaderSectionStyled = styled(HeaderSection)`
  padding: 0 0 2rem;
`;
